/* eslint-disable no-nested-ternary */
import { useEffect } from 'react';
import Highcharts from 'highcharts';

const RelationshipChart = ({ fileMatchPercentage, index }) => {
    const topThresholdPercent = 80;
    const averageThresholdPercent = 50;
    const getColor = () => {
        if (fileMatchPercentage > topThresholdPercent) {
            return '#22992E';
        }
        return fileMatchPercentage > averageThresholdPercent ? '#FFBF1F' : '#C52A1A';
    };
    let pieChart;
    useEffect(() => {
        pieChart = new Highcharts.Chart({
            chart: {
                renderTo: `pie-one-${index}`,
                type: 'pie',
                width: 110,
                height: 110,
                spacingLeft: 0,
                spacingTop: 0,
                spacingBottom: 0,
                spacingRight: 0,
                backgroundColor: '#f2f2f2',
                alignTicks: false,
                animation: false,
            },
            credits: {
                enabled: false,
            },
            title: {
                text: `${fileMatchPercentage}% Match`,
                verticalAlign: 'middle',
                style: {
                    fontWeight: 'bold',
                    fontSize: 14,
                },
            },
            tooltip: {
                enabled: false,
            },
            series: [
                {
                    type: 'pie',
                    name: 'File match percentage',
                    innerSize: '90%',
                    animation: false,
                    data: [
                        {
                            y: fileMatchPercentage,
                            color: getColor(),
                        },
                    ],
                },
            ],
        });
        return () => {
            pieChart.destroy();
        };
    }, [fileMatchPercentage]);

    return (
        <div
            id={`pie-one-${index}`}
            style={{
                height: 120, float: 'right', position: 'relative', top: '-1rem',
            }}
        />
    );
};

export default RelationshipChart;
